module.exports = __webpack_public_path__ + "img/img16.2ec489a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/07/img16.jpg
// module id = 281
// module chunks = 0